import filterRoot from "./FilterRoot.vue";
import { createApp } from "vue";
import { UrlResolver } from "./seo-url-parser";
import { mountReplace } from "../../../utilities/mount-replace";

export async function loadFilterComponent(
    el: string | HTMLElement,
    props: { [key: string]: any }
) {
    const urlResolver = new UrlResolver();
    props = Object.assign({}, props, { urlResolver });
    mountReplace(createApp(filterRoot, props), el);
}
